import Vue from 'vue'
import Vuex from 'vuex'
import Req from '../req/index'
import Mall from './modules/mall'
import Speed from './modules/speed'
import SpeedTelescope from './modules/speedTelescope'
import SpeedShare from './modules/speedShare'
import UserInfo from './modules/userInfo'
import Node from './modules/node'
import Applications from './modules/applications'
import common from '../common/index'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		appid: "",
		local_pid: "",
		hostname: "",
		macaddr: "",
		app_url: {
			qh_arm: "https://tan.ionewu.com/api/jdxb/download/v2/qh_arm",
			qh_x86: "https://tan.ionewu.com/api/jdxb/download/v2/qh_x86",
			qh_dsm7_arm: "https://tan.ionewu.com/api/jdxb/download/v2/qh_dsm7_arm",
			qh_dsm7_x86: "https://tan.ionewu.com/api/jdxb/download/v2/qh_dsm7_x86",
			twm: "https://tan.ionewu.com/api/jdxb/download/v2/twm",
			twm_tos5: "https://tan.ionewu.com/api/jdxb/download/v2/twm_tos5",
			twm_arm: "https://tan.ionewu.com/api/jdxb/download/v2/twm_arm",
			twm_tos5_arm: "https://tan.ionewu.com/api/jdxb/download/v2/twm_tos5_arm",
			wlt: "https://tan.ionewu.com/api/jdxb/download/v2/wlt",
			wlt_arm: "https://tan.ionewu.com/api/jdxb/download/v2/wlt_arm",
			windows: "https://tan.ionewu.com/api/jdxb/download/v2/windows",
			windows_server: "https://tan.ionewu.com/api/jdxb/download/v2/windows_server",
			android: "https://tan.ionewu.com/api/jdxb/download/v2/android",
			ios: "https://apps.apple.com/cn/app/id1630528881",
			mac_dmg: "https://tan.ionewu.com/api/jdxb/download/v2/mac",
			mac_server_dmg: "https://tan.ionewu.com/api/jdxb/download/v2/mac_server",
			mac_appstore: "https://apps.apple.com/cn/app/id1632648733",
		},
		user: {
			uid: "",
			name: "",
			avatar: "",
			owcode: "",
			rkey: "",
			openid: "",
			phone: "",
			left_points: 0,
			all_points: 0,
			last_points: 0,
			vip_left: 0, // vip剩余时长
			leftTimes: 0,
			device_off_num: 0, // 离线设备数量
			device_on_num: 0, // 在线设备数量
			device_service_off_num: 0, // 离线设备服务数量
			device_service_on_num: 0, // 在线设备服务数量
			vip_service_off_num: 0, // VIP离线设备服务数量
			vip_service_on_num: 0, // VIP在线设备服务数量
			mapping_host: "", // 自定义绑定ip
			mapping_port: "", // 自定义绑定端口
			mapping_success_port: 0, // 自定义绑定成功端口
			isAllLenvNas: false, // 是否联想渠道
			vip_service_num: 0
		},
		view: {
			isShowWyjTipsAlert: false,
			isShowHcTipsAlert: false,
			isShowByTipsAlert: false,
		},
		pay: {
			out_trade_no: ""
		},
		client: "web",
		version: "",
		uuid: "",
		mini_windows_version: "1.0.0.2",
		mac: {
			appstore_ver: "" // mac审核版本，用于屏蔽功能
		},
		agree_version: "1.0",
		client_info: {
			isIE: false,
			ieVersion: -1,
			isChrome: false
		},
		product: 2581,
		product2581: 2581,
		bind_list: [],
		curDev: null,
		cur_pid: "",
		limit: {
			times: {
				normal: 15
			},
			bind: {
				normal: 2,
				vip: 1000
			},
			service: {
				normal: 3,
				speed: 4,
				vip: 6
			}
		},
		toast: "",
		nasExPorts: [5080, 5443, 7000, 7001, 8800, 8801, 9007, 9008],
		isShowDownload: 0,//1打开选择设备类型弹窗 2打开选择nas厂商弹窗 3打开群晖弹窗 4打开威联通弹窗 5打开铁威马弹窗 6打开联想弹窗 7海康 8windows
		deviceForSetting: {},
		isLoadForBind: false,
		isShowDeviceInfo: false,
		isShowPayExchange: false,
		isShowLogin: false,
		isShowAddDevice: false,
		expandedKeys: [], //需要展开的节点id数据
		currentKey: null, //当前节点id
	},
	getters: {
		// 是否审核模式
		isAppstoreMode: function (state) {
			if (
				state.client == 'mac' &&
				state.version ==
				state.mac.appstore_ver
			) {
				return true;
			} else {
				return false;
			}
		},
		isRemoteControl: function (state) {
			// state.client == 'web' 
			if ((state.client == 'windows' && state.version > '2.4.4')) {
				return true;
			} else {
				return false;
			}
		}
	},
	mutations: {
		setUser(state) {
			let data = {
				uid: localStorage.getItem("jdxb-uid"),
				openid: localStorage.getItem("jdxb-openid"),
				nick: localStorage.getItem("jdxb-name"),
				headimgurl: localStorage.getItem("jdxb-avatar"),
				owcode: localStorage.getItem("jdxb-owcode"),
				rkey: localStorage.getItem("jdxb-rkey"),
				phone: localStorage.getItem("jdxb-phone"),
			};
			data.nick = data.nick && data.nick != 'undefined' ? data.nick : "小宝用户";
			data.headimgurl = data.headimgurl && data.headimgurl != 'undefined' ? data.headimgurl : "https://cdn.ionewu.com/jdxb_www/images/jdxb_logo.png";
			state.user.uid = data.uid;
			state.user.name = data.nick;
			state.user.avatar = data.headimgurl;
			state.user.owcode = data.owcode;
			state.user.rkey = data.rkey;
			state.user.openid = data.openid;
			state.user.phone = data.phone;
		},
		setClient(state, data) {
			state.client = data;
		},
		setVersion(state, data) {
			state.version = data;
		},
		setAppid(state, data) {
			state.appid = data;
		},
	},
	actions: {
		checkBindList: function (store, [update, cb]) {
			if (update || (store.state.bind_list && store.state.bind_list.length <= 0)) {
				store.dispatch("bindget", [
					function (err, data) {
						if (data && !data.rtn) {
							let lenvNasNum = 0;
							let device_off_num = 0;
							let device_on_num = 0;
							//rtn等于0时，后台不返回此字段
							if (data && data.terms && data.terms.length > 0) {
								store.state.user.isAllLenvNas = false;
								for (
									let index = 0;
									index < data.terms.length;
									index++
								) {
									const element = data.terms[index];

									let pidInfo = common.getInfoByPid(element.peerid);

									if (pidInfo.cid == 101 || pidInfo.cid == 123) {
										lenvNasNum++;
									}

									element.cid = pidInfo.cid;
									element.did = pidInfo.did;

									// 构造ip mac 信息
									element.ip = "";
									element.mac = "";

									if (element.term && !element.term.name) {
										element.term.name = pidInfo.cname + pidInfo.dname;
									}

									if (element.term && element.term.nic) {
										let nic = common.getNicByNics(element.term.nic);
										if (nic) {
											element.ip = nic.ipv4n;
											element.mac = nic.mac;
										}
									}

									if (element.term && element.term.comment) {
										if (element.term.comment == "0") {
											element.term.comment = "";
										}
									}

									if (element.term.status == 1) {
										device_off_num++;
									} else {
										device_on_num++;
									}
								}
							} else {
								store.state.bind_list = [];
							}
							// 更新选中设备
							// 更新选中设备
							if (data?.terms?.length > 0) {
								let storedCurDev = null;
								if (localStorage.getItem("jdxb-cueDev")) {
									storedCurDev = JSON.parse(localStorage.getItem("jdxb-cueDev"));
								}
								if (!storedCurDev && (!store.state.curDev || JSON.stringify(store.state.curDev) === "{}")) {
									store.state.curDev = data.terms[0];
									localStorage.setItem("jdxb-cueDev", JSON.stringify(data.terms[0]));
								} else if (storedCurDev) {
									store.state.curDev = data.terms.find(dev => dev.peerid === storedCurDev.peerid);
								}
								store.state.curDev = store.state.curDev ? store.state.curDev : data.terms[0];
							} else {
								store.state.curDev = null;
							}

							// console.log("store.state.curDev", store.state.curDev);
							// 更新联想设备
							if (
								lenvNasNum == data && data.terms && data.terms.length &&
								data.terms.length > 0
							) {
								store.state.user.isAllLenvNas = true;
							}
							// 更新离线在线数量
							store.state.user.device_off_num = device_off_num;
							store.state.user.device_on_num = device_on_num;
							store.state.bind_list = data.terms;

							cb && cb(err, JSON.parse(JSON.stringify(store.state.bind_list || [])));


						} else if (data && data.rtn == 10109) {
							store.dispatch("logout", []);
							cb && cb(err, JSON.parse(JSON.stringify(store.state.bind_list || [])));

						} else if (data && data.rtn == 10100) {

							cb && cb(null, JSON.parse(JSON.stringify([])));
						}
					},
				]);
			} else {
				// console.log("cb3", store.state.bind_list)
				cb && cb(null, JSON.parse(JSON.stringify(store.state.bind_list || [])));

			}
		},
		logout: function (store, [cb]) {
			store.state.user.uid = "";
			store.state.user.openid = "";
			store.state.user.owcode = "";
			store.state.user.icon = "";
			store.state.user.name = "";
			store.state.user.phone = "";
			store.state.user.rkey = "";

			localStorage.setItem("jdxb-uid", "");
			localStorage.setItem("jdxb-openid", "");
			localStorage.setItem("jdxb-owcode", "");
			localStorage.setItem("jdxb-avatar", "");
			localStorage.setItem("jdxb-name", "");
			localStorage.setItem("jdxb-phone", "");
			localStorage.setItem("jdxb-rkey", "");

			// window.location.reload();
			store.state.isShowLogin = true;
			cb ? cb(null, null) : null;
		},
		statAlive: function (store, [cb]) {
			let data = {
				"pid": store.state.local_pid,
				"sid": 0,
				"sname": "owjdxb",
				"product": store.state.product,
				"sn": store.state.macaddr,
				"ver": "1.1.0" // 为了绑定不校验t,s
			}
			Req.stat.alive(data, cb);
		},
		deviceName: function (store, [pid, name, cb]) {
			let data = {
				pid: pid,
				name: name,
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
			}
			Req.node.deviceName(data, cb);
		},
		nodeDeviceInfo: function (store, [pid, cb]) {
			let data = {
				pid: pid,
				owcode: store.state.user.owcode,
			}
			Req.node.nodeDeviceInfo(data, cb);
		},
		deviceBandwidth: function (store, [pid, cb]) {
			let data = {
				pid: pid,
				owcode: store.state.user.owcode,
			}
			Req.node.deviceBandwidth(data, cb);
		},
		bookRegister: function (store, [activecode, cb]) {
			let data = {
				activecode: activecode,
				owcode: store.state.user.owcode,
				uid: store.state.user.uid,
				product: store.state.product2581,
			}
			Req.node.bookRegister(data, cb);
		},
		getPidByMacSn: function (store, [appid, mac, sn, cb]) {
			let data = {
				appid: appid,
				mac: mac,
				sn: sn
			}
			Req.node.getPid(data, cb);
		},
		getServerTimes: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
			}
			Req.user.getServerTimes(data, cb);
		},
		updateServerTimes: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
			}
			Req.user.updateServerTimes(data, cb);
		},
		sendUserlog: function (store, [type, msg, cb]) {
			let data = {
				uid: store.state.user.uid,
				local_pid: store.state.local_pid,
				client: store.state.client,
				version: store.state.version,
				type: type,
				msg: msg
			}
			Req.user.log(data, cb);
			// TDAPP.onEvent(type);
		},
		login: function (store, [code, cb]) {
			let data = {
				code: code
			}
			Req.user.login(data, cb);
		},
		vipLeft: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode
			}
			Req.speedTelescope.left(data, function (err, data) {
				if (!err) {
					store.state.user.vip_left = data.data.left;
				}
				cb ? cb(err, data) : null
			});
		},
		updateLocalApiHost: function (store, [host, cb]) {
			store.state.localApiHost = host;
			Req.owapp.setLocalApiHost(host, cb);
		},
		getSysInfo: function (store, [cb]) {
			let req = {};
			Req.owapp.getSysInfo(req, function (err, data) {
				cb ? cb(err, data) : null;
			});
		},
		sendCode: function (store, [phone, cb]) {
			let data = {
				phone: phone,
				stamp: parseInt(new Date().getTime() / 1000),
			}
			Req.user.sendCode(data, cb);
		},
		loginBind: function (store, [phone, code, uid, cb]) {
			let data = {
				phone: phone,
				phonecode: code,
				uid: uid,
			}
			Req.user.loginBind(data, cb);
		},
		sendLoginBindCode: function (store, [phone, uid, cb]) {
			let data = {
				phone: phone,
				uid: uid,
			}
			Req.user.sendLoginBindCode(data, cb);
		},
		phoneLogin: function (store, [phone, code, cb]) {
			let data = {
				phone: phone,
				answer: code,
				stamp: parseInt(new Date().getTime() / 1000),
			}
			Req.user.phoneLogin(data, cb);
		},
		nodelist: function (store, [peerid, cb]) {
			let data = {
				uid: store.state.user.uid,
				peerid: peerid,
				owcode: store.state.user.owcode,
				product: 2581,
				icon: true
			}
			Req.node.nodelist(data, cb);
		},
		nodeupdate: function (store, [peerid, mac, name, cb]) {
			let data = {
				uid: store.state.user.uid,
				peerid: peerid,
				mac: mac,
				name: name,
				owcode: store.state.user.owcode,
				product: 2581,
			}
			Req.node.nodeupdate(data, cb);
		},
		bindget: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				product: 2581
			}
			Req.node.bindget(data, cb);
		},
		bindset: function (store, [del, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				del: del
			}
			Req.node.bindset(data, cb);
		},
		nodeUnbind: function (store, [pid, cb]) {
			let data = {
				uid: store.state.user.uid,
				token: store.state.user.owcode,
				product: 2581,
				pid: pid
			}
			Req.node.unbind(data, cb);
		},
		nodeRegister: function (store, [pid, t, s, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				product: 2581,
				pid: pid,
				t: parseInt(t),
				s: parseInt(s),
			}
			Req.node.register(data, cb);
		},
		usrdata: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				product: 2581,
			}
			Req.node.usrdata(data, cb);
		},
		usrdataset: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				data: {
					guide_readed: true
				}
			}
			Req.node.usrdataset(data, cb);
		},
		scan: function (store, [peerid, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				peerid: peerid,
				product: 2581,
			}
			Req.node.scan(data, cb);
		},
		scanlist: function (store, [peerid, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				peerid: peerid,
				product: 2581,
				icon: true
			}
			Req.node.scanlist(data, cb);
		},
		speclist: function (store, [peerid, filter, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				peerid: peerid,
				product: 2581,
				icon: true,
				filter: filter,
			}
			Req.node.speclist(data, cb);
		},
		nodelistset: function (store, [peerid, add, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				peerid: peerid,
				add: add,
				product: 2581,
			}
			Req.node.nodelistset(data, cb);
		},
		nodelistsetDel: function (store, [peerid, del, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				peerid: peerid,
				del: del,
				product: 2581,
			}
			Req.node.nodelistset(data, cb);
		},
		nodelistmanset: function (store, [peerid, add, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				peerid: peerid,
				AddMan: add,
				product: 2581,
			}
			Req.node.nodelistset(data, cb);
		},
		nodelistmansetdel: function (store, [peerid, del, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				peerid: peerid,
				DelMan: del,
				product: 2581,
			}
			Req.node.nodelistset(data, cb);
		},
		webWakeup: function (store, [peerid, mac, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				peerid: peerid,
				macstr: mac,
				product: 2581
			}
			Req.node.webWakeup(data, cb);
		},
		portal: function (store, [peerid, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				remote_peerid: peerid,
				stamp: parseInt(new Date().getTime() / 1000),
			}
			Req.node.portal(data, function (err, res) {
				if (!err && res && res.rtn == 0) {
					store.dispatch("sendUserlog", ["remote_s_portal", JSON.stringify(data) + JSON.stringify(res)]);
				} else {
					store.dispatch("sendUserlog", ["remote_f_portal", JSON.stringify(data) + JSON.stringify(res)]);
				}
				cb ? cb(err, res) : null;
			});
		},
		createTunnel: function (store, [peerid, accessToken, authToken, addr, cb]) {
			let data = {
				uid: store.state.user.uid,
				callee: peerid,
				authToken: authToken,
				accessToken: accessToken,
				addr: addr,
				sequenceID: parseInt(new Date().getTime() / 1000),
			}
			Req.node.createTunnel(data, function (err, res) {
				if (!err && res && res.status == 1) {
					store.dispatch("sendUserlog", ["remote_s_createTunnel", JSON.stringify(data) + JSON.stringify(res)]);
				} else {
					store.dispatch("sendUserlog", ["remote_f_createTunnel", JSON.stringify(data) + JSON.stringify(res)]);
				}
				cb ? cb(err, res) : null;
			});
		},
		startMapSrv: function (store, [peerid, accessToken, authToken, svFwdIP, svFwdPort, addr, rule, cb]) {
			let data = {
				uid: store.state.user.uid,
				callee: peerid,
				authToken: authToken,
				accessToken: accessToken,
				sequenceID: parseInt(new Date().getTime() / 1000),
				svFwdIP: svFwdIP,
				svFwdPort: svFwdPort,
				addr: addr,
				rule: rule,
			}
			Req.node.startMapSrv(data, function (err, res) {
				cb ? cb(err, res) : null;
			});
		},
		getUserImagebackupLog: function (store, [pid, type, page, count, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				type: type,
				pid: pid,
				page: page,
				count: count,
			}
			Req.user.imagebackup.list(data, cb);
		},
		getUserImagebackupPath: function (store, [pid, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				pid: pid,
			}
			Req.user.imagebackup.getPath(data, cb);
		},
		setUserImagebackupPath: function (store, [path, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				pid: store.state.local_pid,
				path: path
			}
			Req.user.imagebackup.setPath(data, cb);
		},
		addWakeup: function (store, [mac, name, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				mac: mac,
				name: name
			}
			Req.user.addWakeup(data, cb);
		},
		delWakeup: function (store, [mac, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				mac: mac,
			}
			Req.user.delWakeup(data, cb);
		},
		getWakeups: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				page: 1,
				count: 100
			}
			Req.user.getWakeups(data, cb);
		},
		getExchange: function (store, [code, cb]) {
			let data = {
				uid: store.state.user.uid,
				owcode: store.state.user.owcode,
				code: code
			}
			Req.user.getExchange(data, cb);
		},
	},
	modules: {
		Mall,
		Speed,
		SpeedTelescope,
		SpeedShare,
		UserInfo,
		Node,
		Applications
	}
})
